import { render, staticRenderFns } from "./FantasyStatistics.vue?vue&type=template&id=a59db220&"
import script from "./FantasyStatistics.vue?vue&type=script&lang=js&"
export * from "./FantasyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./FantasyStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports